import dayjs from "dayjs";
import { DISPLAY_DATE } from "constants/date";

// A recurring journal entry's first occurrence always lands on the last day
// of the month following the entry's transaction date, e.g. Jul 31 -> Aug 31.
export const getRecurringEntryStartDate = (transactionDate: string): string =>
  dayjs(transactionDate).add(1, "month").endOf("month").format(DISPLAY_DATE);
